import i18n from '@/locales/index'
const QuestionList = [
  {
    index: 0,
    type: 'multi',
    question: i18n.t('upgrade_page_views_settled_in_question_question_1172'),
    options: [
      {
        id: 'A',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1173'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1174'),
        isSelected: false
      },
      {
        id: 'C',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1175'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1176'),
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C', 'D']
  },
  {
    index: 1,
    type: 'multi',
    question: i18n.t('upgrade_page_views_settled_in_question_question_1177'),
    options: [
      {
        id: 'A',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1178'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1179'),
        isSelected: false
      },
      {
        id: 'C',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1180'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1181'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'E',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1182'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'F',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1183'),
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C', 'D', 'E', 'F']
  },
  {
    index: 2,
    type: 'multi',
    question: i18n.t('upgrade_page_views_settled_in_question_question_1184'),
    options: [
      {
        id: 'A',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1185'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1186'),
        isSelected: false
      },
      {
        id: 'C',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1187'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1188'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'E',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1189'),
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C']
  },
  {
    index: 3,
    type: 'multi',
    question: i18n.t('upgrade_page_views_settled_in_question_question_1190'),
    options: [
      {
        id: 'A',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1191'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1192'),
        isSelected: false
      },
      {
        id: 'C',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1193'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1194'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'E',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1195'),
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C']
  },
  {
    index: 4,
    type: 'multi',
    question: i18n.t('upgrade_page_views_settled_in_question_question_1196'),
    options: [
      {
        id: 'A',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1197'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1198'),
        isSelected: false
      },
      {
        id: 'C',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1199'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1200'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'E',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1201'),
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['B', 'C', 'D', 'E']
  },
  {
    index: 5,
    type: 'multi',
    question: i18n.t('upgrade_page_views_settled_in_question_question_1202'),
    options: [
      {
        id: 'A',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1203'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'B',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1204'),
        isSelected: false
      },
      {
        id: 'C',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1205'),
        isSelected: false,
        isCorrectAnswer: true
      },
      {
        id: 'D',
        text: i18n.t('upgrade_page_views_settled_in_question_question_1206'),
        isSelected: false,
        isCorrectAnswer: true
      }
    ],
    userAnswer: [],
    answer: ['A', 'B', 'C', 'D']
  }
];

export default QuestionList;
